module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "admin-fields"
  }, [_c('div', {
    staticClass: "panelheader border-3"
  }, [_c('div', {
    staticClass: "title"
  }, [_c('el-breadcrumb', {
    attrs: {
      "separator": "/"
    }
  }, [_c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/admin/clients'
      }
    }
  }, [_vm._v("Clients Admin")]), _vm._v(" "), _c('el-breadcrumb-item', {
    attrs: {
      "to": {
        path: '/admin/clients/' + _vm.clientId
      }
    }
  }, [_vm._v("Sites Admin")]), _vm._v(" "), _c('el-breadcrumb-item', [_vm._v(_vm._s(_vm.pageName))])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "btn-wrapper"
  }, [_c('el-button', {
    attrs: {
      "type": "add"
    },
    on: {
      "click": _vm.onNewField
    }
  }, [_vm._v("New Field")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "fields"
  }, [_c('h2', [_vm._v(_vm._s(_vm.siteName))]), _vm._v(" "), (_vm.newField) ? _c('div', [_c('newfield', {
    attrs: {
      "fieldData": _vm.fieldData,
      "siteId": _vm.id
    },
    on: {
      "close": _vm.onClose
    }
  })], 1) : (_vm.editField) ? _c('div', [_c('editfield', {
    attrs: {
      "fieldData": _vm.fieldData
    },
    on: {
      "close": _vm.onClose
    }
  })], 1) : _c('div', [(!_vm.reloading) ? _c('fieldtable', {
    attrs: {
      "clientId": _vm.clientId,
      "id": _vm.id
    },
    on: {
      "editField": _vm.onEditField,
      "deleteField": _vm.onDeleteField
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0067779d","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/Fields/Fields.vue
// module id = 1023
// module chunks = 9